export const WAREHOUSE_HISTORY = '/warehouseHistory';
export const PROGRAM_CREATOR = '/programCreator';
